import { ChevronLeftLineLight2 } from '@poli-digital/react';
import { Button, Icon } from '@polichat/flamboyant';
import { useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import {
  showBlockTwo,
  showDetailsComponent,
} from '../../../../../store/modules/chat/actions';
import { toast } from 'react-toastify';
import getContactIdCrm from 'src/components/tools/integrations/crmRequests/getContactIdCrm';
import renewToken from '../../../../tools/integrations/crmRequests/renewToken';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import { setCrmUserDisabled } from 'src/store/modules/chat/actions';

export function EmbedAddOpportunitiesOrTickets(props) {
  const tcrmRef = useRef(null);
  const dispatch = useDispatch();
  const contact = useSelector((state) => state?.chat?.currentContact?.contact);
  const crmToken = useSelector((state) => state?.chat?.crmToken);
  const isDarkMode = useSelector((state) => state?.theme?.isDarkMode);
  const opportunitiesTitle = useGlotaT('spa.details.opportunities.title');
  const ticketsTitle = useGlotaT('spa.details.tickets.title');
  const opportunityCreatedText = useGlotaT('spa.details.opportunities.opportunityCreated');
  const ticketCreatedText = useGlotaT('spa.details.tickets.ticketCreated');
  const errorCreatingOpportunityText = useGlotaT('spa.details.opportunities.errorCreatingOpportunity');
  const errorCreatingTicketText = useGlotaT('spa.details.tickets.errorCreatingTicket');
  const tryAgainText = useGlotaT('spa.details.opportunities.tryAgain');

  const getContactCrm = async () => {
    try {
      const response = await getContactIdCrm(contact);
      if (response && response.data) {
        return response?.data;
      }
    } catch (error) {
      console.error('Error getting contactIdCRM: ', error);
      return undefined;
    }
  };

  const renewCrmToken = async () => {
    try {
      const response = await renewToken();
      if (response && response.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        dispatch(setCrmUserDisabled());
        toast.error(error?.response?.data?.message || 'Seu usuário ainda não está habilitado para o CRM. Solicite a um administrador.');
      } else {
        console.error('Error getting new token: ', error);
      }
      return undefined;
    }
  };

  const handleCardSaved = (data) => {
    if (data?.status === 1) {
      toast.success(`${props?.wichAction === 'opportunities' ? opportunityCreatedText : ticketCreatedText} com sucesso!`);
      return props.openEmbedModal();
    }
    return toast.error(`Não foi possível criar ${props?.wichAction === 'opportunities' ? 'a oportunidade' : 'o ticket'}. \n ${tryAgainText}`);
  };

  const applyThemeToIframe = () => {
    if (tcrmRef.current?.updateTheme) {
      tcrmRef.current.updateTheme(isDarkMode);
    }
  };

  useEffect(() => {
    if (!crmToken) return;

    if (tcrmRef.current) {
      tcrmRef.current.events.clearListeners();
      tcrmRef.current = null;
    }

    const TCRM = new TCRMEmbed();
    tcrmRef.current = TCRM;

    const runCrm = async (token) => {
      const contactIdCRM = await getContactCrm();

      TCRM.config({
        url: `${process.env.REACT_APP_EMBED_CRM_URL}/embed/${props?.wichAction}/add?contactId=${Number(contactIdCRM?.integrationId)}`,
        apiHost: process.env.REACT_APP_EMBED_CRM_API_URL,
        userToken: token,
        iframeId: 'embed-crm',
        formsSettings: {
          keepOpenOnUpdate: true
        },
        layout: {
          darkMode: isDarkMode
        }
      });
      TCRM.events.addListener("cardSaved", handleCardSaved);
      TCRM.events.addListener("forcedLogout", reRunCrm);
      if (process.env.REACT_APP_ENV === 'production') {
        TCRM.auth().catch(reRunCrm);
      }
      TCRM.show();

      applyThemeToIframe();
    };

    const reRunCrm = async () => {
      const { token } = await renewCrmToken();
      if (token) {
        await runCrm(token);
      }
    };

    runCrm(crmToken);

    return () => {
      if (tcrmRef.current) {
        tcrmRef.current.events.clearListeners();
        tcrmRef.current = null;
      }
    };
  }, [props?.wichAction, crmToken, isDarkMode]);

  useEffect(() => {
    applyThemeToIframe();
  }, [isDarkMode]);

  return (
    <div className="opportunitiesAndTicketsEmbeded">
      <div className="title" onClick={props.openEmbedModal}>
        <ChevronLeftLineLight2 />
        <span>
          <strong>{props?.wichAction === 'opportunities' ? opportunitiesTitle : ticketsTitle}</strong>
        </span>
        <div className="closeDetails">
          <Button
            color="link"
            onClick={() => {
              isMobile && dispatch(showBlockTwo());
              dispatch(showDetailsComponent(false));
            }}
          >
            <Icon icon="poli-icon pi-close-fill" />
          </Button>
        </div>
      </div>
      <div className="opportunities h-100">
        <iframe
          id="embed-crm"
          title="Embed CRM"
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </div>
    </div>
  );
}
